import * as React from 'react'

import { Box, RadioButton, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

interface Props {
  label: string
  checked: boolean
  text: string
  onClick: () => void
}

const HeaderComponent = ({ label, checked, text, onClick }: Props) => {
  return (
    <div>
      <RadioButton label={label} value={label} onChange={() => onClick()} checked={checked} />
      <Box paddingX="s8" paddingTop="s8">
        <Text.Normal size="200">{text}</Text.Normal>
      </Box>
    </div>
  )
}

export default observer(HeaderComponent)
